
import { defineComponent } from 'vue';
import WYSIWYG from './HokTextArea/WYSIWYG.vue';

const focus = {
	inserted(el, binding, vnode) {
		const $iPhone = vnode?.context?.$isMobile?.apple?.device;
		if (!binding || $iPhone) {
			return;
		}
		if (vnode.context.autofocus && !el.gotFocused) {
			vnode.context.$emit('focus');

			setTimeout(() => {
				el.gotFocused = true;
				el.focus();
			}, 300); // by default wait 300ms, in case there is any transition ongoing (max 300 ms)
		}
	}
};

export default defineComponent({
	name: 'HokTextArea',
	directives: { focus },
	components: { WYSIWYG },
	data() {
		return {
			focused: false,
			internalValue: this.value
		};
	},
	computed: {
		myClasses() {
			const classes: string[] = [];
			if (this.focused || this.internalValue?.trim().length) {
				classes.push('input--filled');
			}
			if (this.focused) {
				classes.push('input--active');
			}
			if (this.fullwidth) {
				classes.push('max-w-full');
			}
			return classes;
		},
		getHeight(): string {
			switch (this.boxHeight) {
				case 'small':
					return 'h-32';
				case 'medium':
					return 'h-40';
				case 'big':
				default:
					return 'h-64';
			}
		},
		wysiwygInput() {
			return this.$refs.wysiwygInput as any;
		}
	},
	created() {
		if (this.id === 'hoktextarea') {
			console.warn('HokTextArea without explicit id', this);
		}
	},
	methods: {
		hasValue(object: any): object is { value: string } {
			return typeof object === 'object' && 'value' in object;
		},
		setContent(text: string): string {
			if (this.wysiwyg) {
				return this.wysiwygInput.setContent(text);
			}
			this.internalValue = text;
			return this.internalValue;
		},
		focus() {
			this.focused = true;
			this.$emit('focus');
		},
		blur() {
			this.focused = false;
			this.$emit('blur');
		},
		changeInternalVal($event) {
			this.internalValue = $event;
			this.$emit('input', $event);
		},
		onValueChanged() {
			this.internalValue = this.value;
		}
	},
	props: {
		showFullScreenButton: { type: Boolean, default: true },
		noMaxWidth: { type: Boolean, default: true },
		name: { type: String, default: '' },
		value: { type: String, default: '' },
		id: { type: String, default: 'hoktextarea', required: true },
		maxLength: { type: Number, default: 0 },
		styling: { type: String, default: 'b2c' },
		boxHeight: {
			type: String,
			default: 'big',
			validator: (value: string) => ['small', 'medium', 'big'].includes(value)
		},
		fullwidth: {
			type: [String, Boolean],
			default: false,
			validator: (value: string | boolean) => [false, 'mobile', 'always'].includes(value)
		},
		required: { type: Boolean, default: false },
		wysiwyg: { type: Boolean, default: false },
		disableResize: { type: Boolean, default: false },
		isLoadingExternalContent: { type: Boolean, default: false, required: false }
	},
	watch: {
		value: [
			{
				handler: 'onValueChanged'
			}
		]
	}
});
